module.exports = "\r\n.img-fornecedor{\r\n  max-width:120px;\r\n  max-height:40px;\r\n}\r\n"